import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/site/PageHero';
import { services } from '../mock';
import { CtaBanner } from '../components/site/BottomSections';
import { ArrowUpRight } from 'lucide-react';

export default function Services() {
  return (
    <div>
      <PageHero
        eyebrow="What We Do"
        title="From land to keys — we do it all."
        subtitle="Seven carefully crafted services designed for hill‑country living."
        image="https://ewenrealtors.com/assets/images/our-services.jpg"
      />

      {/* Icon strip */}
      <section className="bg-[#0f1a14] border-y border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-px bg-white/5">
          {services.map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`} className="bg-[#0f1a14] px-4 py-6 flex flex-col items-center text-center hover:bg-[#152720] transition-colors group">
              <div className="h-12 w-12 grid place-items-center bg-[#c9a56a]/20 group-hover:bg-[#c9a56a] transition-colors mb-3">
                <img src={s.icon} alt="" className="h-6 w-6" style={{ filter: 'invert(1)' }} />
              </div>
              <div className="text-white/80 group-hover:text-[#c9a56a] text-xs uppercase tracking-widest transition-colors">{s.title.split(' ')[0]}</div>
            </Link>
          ))}
        </div>
      </section>

      {/* Intro */}
      <section className="bg-[#f6f1e7] py-24">
        <div className="mx-auto max-w-4xl px-6 lg:px-10 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-12 bg-[#8a6b3a]" />
            <span className="text-[#8a6b3a] text-xs uppercase tracking-[0.3em]">Our Services</span>
            <div className="h-px w-12 bg-[#8a6b3a]" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-[#0f1a14] leading-[1.1]">A single team for every step of your real-estate journey.</h2>
          <p className="text-[#0f1a14]/70 leading-relaxed text-lg mt-6">
            No more hopping from realtor to broker to contractor. Whether you are buying land, building a home, sorting paperwork or picking a colour palette, our in‑house team has you covered.
          </p>
        </div>
      </section>

      {/* Service cards */}
      <section className="bg-white py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <Link key={s.slug} to={`/services/${s.slug}`} className="group block overflow-hidden bg-[#f6f1e7]/50 border border-[#0f1a14]/10 hover:border-[#8a6b3a] transition-colors">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={s.hero} alt={s.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f1a14]/70 via-transparent to-transparent" />
                <div className="absolute top-4 left-4 h-10 w-10 bg-[#c9a56a] grid place-items-center">
                  <img src={s.icon} alt="" className="h-5 w-5" style={{ filter: 'brightness(0)' }} />
                </div>
              </div>
              <div className="p-6">
                <div className="font-serif text-6xl text-[#c9a56a]/30 leading-none">{String(i + 1).padStart(2, '0')}</div>
                <h3 className="font-serif text-2xl text-[#0f1a14] mt-2 group-hover:text-[#8a6b3a] transition-colors">{s.title}</h3>
                <div className="h-px w-8 bg-[#8a6b3a] my-4 group-hover:w-16 transition-all duration-500" />
                <p className="text-[#0f1a14]/70 text-sm leading-relaxed line-clamp-3">{s.lead}</p>
                <div className="mt-5 inline-flex items-center gap-1 text-[#8a6b3a] text-xs uppercase tracking-widest">Learn more <ArrowUpRight className="h-3 w-3" /></div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Bit more */}
      <section className="bg-[#0f1a14] py-24">
        <div className="mx-auto max-w-4xl px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-[#c9a56a]" />
            <span className="text-[#c9a56a] text-xs uppercase tracking-[0.3em]">A bit more</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-white leading-[1.1]">Every service is built to grow your investment and simplify your journey.</h2>
          <p className="text-white/70 mt-6 leading-relaxed text-lg">
            Whether you are a landlord, investor, developer, buyer or seller, we bring innovation, quality, flexibility and honest value — across every stage from planning to completion.
          </p>
          <p className="text-white/70 mt-4 leading-relaxed text-lg">
            Our regional experts collaborate closely to deliver tailored solutions for individual properties, portfolios and luxury estates across Uttarakhand.
          </p>
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
